import { Injectable, Inject, PLATFORM_ID } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { isPlatformBrowser, DOCUMENT } from "@angular/common";
import { filter } from "rxjs/operators";

@Injectable()
export class TaboolaService {
  private lastCanonicalUrl: string;
  constructor(
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: object,
    @Inject(DOCUMENT) private doc: Document,
  ) {
    if (isPlatformBrowser(this.platformId)) {
      this.router.events.pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd)).subscribe(() => this.markNewPage()); // ← sólo en cliente
    }
  }

  private markNewPage(): void {
    if (!isPlatformBrowser(this.platformId)) return;

    const t = ((globalThis as any)._taboola = (globalThis as any)._taboola || []);
    t.push({ notify: "newPageLoad" });
    const canonicalURL = this.doc.querySelector('link[rel="canonical"]')?.getAttribute("href") || this.doc.location.href;
    this.lastCanonicalUrl = canonicalURL;
    t.push({ article: "auto", url: canonicalURL });
  }

  /** Metodo para recargar la información de la url para los anuncios de taboola */
  public reloadPushTaboola(): void {
    const canonical = this.doc.querySelector('link[rel="canonical"]')?.getAttribute("href") || this.doc.location.href;
    if (canonical !== this.lastCanonicalUrl) {
      this.lastCanonicalUrl = canonical;
      this.markNewPage();
    }
  }

  /** Llamado por la directiva lazy cuando el sentinel entra en viewport */
  renderPlacement(): void {
    if (!isPlatformBrowser(this.platformId)) return;

    const t = ((globalThis as any)._taboola = (globalThis as any)._taboola || []);
    t.push({
      mode: "alternating-thumbnails-a",
      container: "taboola-below-article-thumbnails",
      placement: "Below Article Thumbnails",
      target_type: "mix",
    });
    t.push({ flush: true });
  }
}
